import { toRef, computed } from "vue";
export function usePayoutStatusHelper(props) {
    const payout = toRef(props, "value");
    const isMissing = computed(() => {
        return (payout.value.status == "PENDING" &&
            payout.value.processingResolution == "USER_ERROR");
    });
    const isUnknown = computed(() => {
        return (payout.value.status == "PENDING" &&
            payout.value.processingResolution &&
            payout.value.processingResolution != "UNKNOWN");
    });
    const statusDate = computed(() => {
        switch (payout.value.status) {
            case "PENDING":
                return payout.value.createdAt;
            case "PAID":
                return payout.value.confirmedAt;
            case "CANCELLED":
                return payout.value.cancelledAt ? payout.value.cancelledAt : null;
            default:
                return null;
        }
    });
    const statusClass = computed(() => {
        switch (payout.value.status) {
            case "PAID":
                return "text-edit-green";
            case "CANCELLED":
            case "PENDING":
                return "text-edit";
            default:
                return "";
        }
    });
    const chipColor = computed(() => {
        switch (payout.value.status) {
            case "NOT_PAID":
                return "secondary";
            case "IN_PROGRESS":
            case "PENDING":
            case "WARNING":
            case "CANCELLED":
                return "edit";
            case "PAID":
                return "edit-green";
            default:
                return "grey";
        }
    });
    return {
        isMissing,
        isUnknown,
        statusDate,
        statusClass,
        chipColor
    };
}
